// Shared upload validation for the Ad Library — used by both the upload modal
// and the drag-and-drop drop zones so a dropped file is held to the exact same
// rules as one picked through the modal (mirrors services/contents uploadContent).

export const MAX_SIZE_MB = 500

// Accepted image formats — explicit allow-list (NOT `image/*`), so formats like
// WebP, GIF, BMP, HEIC, etc. are rejected. jpg and jpeg both report image/jpeg.
export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg']
export const ACCEPTED_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg']

// `accept` string for <input>/antd Dragger. Images are restricted to the
// allow-list above (the picker won't even show e.g. .webp); video stays broad
// and mp3 audio is allowed.
export const ACCEPT = [...ACCEPTED_IMAGE_TYPES, 'video/*', 'audio/mp3', '.mp3'].join(',')

export const isAllowedType = (file) => {
  const type = (file && file.type) || ''
  if (type.startsWith('image/')) return ACCEPTED_IMAGE_TYPES.includes(type)
  return type.startsWith('video/') || type === 'audio/mpeg'
}

export const isAllowedSize = (file) => file && file.size / 1024 / 1024 <= MAX_SIZE_MB
